import { breakpoints } from "@brightagency/headstart-common";
import styled from "styled-components";

export const HeroTitle = styled.h1`
    color: white;
    font-size: 28px;
    line-height: 1.2;
    font-weight: 400;

    strong {
        font-weight: 800;
    }

    ${breakpoints.large} {
        font-size: 40px;
    }
`;
